import React from 'react';
import './WBT.css';

function WBT() {
  return (
    <div className="wbt-container" style={{ height: '100vh' }}>
      <iframe
        src="https://service9007.szapfs.org/"
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="WBT Platform"
      />
    </div>
  );
}

export default WBT;
